import { combineEpics } from 'redux-observable';
import { GroupPermission, ReduxAction } from '@repo/utils/types';
import { createSharingActions, createSharingEpicActionCreators, createSharingEpics } from './utils';
import AppState from '../../reducers/app-state';

const actionCreators = createSharingEpicActionCreators('GROUP');

export const {
  fetchShareStatus: fetchGroupShareStatus,
  shareWithEmail: shareGroupWithEmail,
  unshareWithSharee: unshareGroupWithSharee,
  addPermissionForSharee: addGroupPermissionForSharee,
  removePermissionForSharee: removeGroupPermissionForSharee,
  sharePublicly: shareGroupPublicly,
  unsharePublicly: unshareGroupPublicly,
  addPublicPermission: addGroupPublicPermission,
  removePublicPermission: removeGroupPublicPermission,
} = createSharingActions<GroupPermission>('GROUP', actionCreators);

export const groupShareStatusesEpic = combineEpics<ReduxAction, any, AppState>(
  ...createSharingEpics('GROUP', actionCreators),
);
